import { Injectable } from "@angular/core";

@Injectable()
export class EventService {
  // Make topics public for testing purposes
  public topics: any;

  constructor() {
    this.topics = {};
  }

  public subscribe(topic: string, listener: any) {
    if (!this.topics.hasOwnProperty(topic)) {
      this.topics[topic] = [];
    }

    const index = this.topics[topic].push(listener) - 1;

    return {
      unsubscribe: () => {
        this.topics[topic].splice(index, 1);
      },
    };
  }

  public publish(topic: string, data?: any) {
    if (!this.topics.hasOwnProperty(topic)) {
      return;
    }

    this.topics[topic].forEach((listener: any) => {
      listener(data);
    });
  }
}
